var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('h2',[_vm._v("Security")]),_c('button',{staticClass:"btn btn-secondary full-width mt-4",attrs:{"type":"button"},on:{"click":_vm.resetPassword}},[_c('span',[_vm._v("Change Password")])])])}
var staticRenderFns = []

export { render, staticRenderFns }